import { useMemo } from 'react';
import { useGetBenefitsUserOnboardingQuery } from '../services/userOnboardingApi';
import { computeShouldShowBenefitsOnboardingEntry, VOUCHER_ONBOARDING_TYPE_WELCOME } from '../types';
export function useEmissorBenefitsOnboardingEntry({ hasActivatedEmissorContract, }) {
    const skipQuery = !hasActivatedEmissorContract;
    const { data, isError, isLoading, isFetching, isUninitialized } = useGetBenefitsUserOnboardingQuery({ type: VOUCHER_ONBOARDING_TYPE_WELCOME }, { skip: skipQuery });
    const shouldShowOnboardingEntry = useMemo(() => computeShouldShowBenefitsOnboardingEntry({
        enabled: true,
        hasActiveContract: hasActivatedEmissorContract,
        isEligible: true,
        isQuerySkipped: skipQuery,
        isQueryError: isError,
        isQueryLoading: isLoading,
        isQueryFetching: isFetching,
        isQueryUninitialized: isUninitialized,
        onboardingItems: data,
    }), [hasActivatedEmissorContract, skipQuery, isError, isLoading, isFetching, isUninitialized, data]);
    return { shouldShowOnboardingEntry };
}
